// src/features/system/developer/components/video-gallery/BucketChips.tsx
import React from 'react';
import type { FeedBucket } from './types';
import { formatBytes } from './format';

interface Props {
  buckets: FeedBucket[];
  activeKey: string;
  onSelect: (key: string) => void;
}

export default function BucketChips({ buckets, activeKey, onSelect }: Props) {
  if (!buckets.length) return null;
  return (
    // flex-nowrap + parent overflow-x-auto = single-row horizontal scroll (TikTok tabs)
    <div className="flex flex-nowrap gap-2 py-0.5">
      {buckets.map((b) => {
        const active = b.key === activeKey;
        return (
          <button
            key={b.key}
            type="button"
            onClick={() => onSelect(b.key)}
            className={[
              'shrink-0 px-3 py-1 rounded-full text-[11px] font-semibold transition-all duration-150',
              'border backdrop-blur-md whitespace-nowrap',
              active
                ? 'border-neon_orange-300/80 text-neon_orange-200 bg-neon_orange-500/15 shadow-sm shadow-neon_orange-500/20'
                : 'border-white/10 text-neutral-400 bg-black/30 hover:border-white/25 hover:text-neutral-200',
            ].join(' ')}
            title={`${b.count} item${b.count === 1 ? '' : 's'} · ${formatBytes(b.totalBytes)}`}
            aria-pressed={active}
          >
            {b.label}
            <span
              className={[
                'ml-1.5 inline-flex items-center justify-center',
                'min-w-[1.25rem] px-1 py-px rounded-full text-[9px] font-bold',
                active ? 'bg-neon_orange-500/25 text-neon_orange-200' : 'bg-white/10 text-neutral-500',
              ].join(' ')}
            >
              {b.count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
